import React from "react";

const styles = {
	containerField: {
		display: "flex",
	},
	textField: {
		paddingLeft: 10,
		fontSize: "0.8em",
	},
};

const textField = (field) => ({
	fontWeight: 600,
	color: field === "Oui" ? "#098827" : field === "Non" ? "#ab1a1a" : "black",
});

const ContainerFieldPrescription = ({ label, icon, field, extra, style, secondExtra = null, colorExtra = null }) => {
	field = field === true ? "Oui" : field === false ? "Non" : field;

	return (
		<div style={{ ...styles.containerField, ...style }}>
			{icon !== undefined && icon}
			<span style={styles.textField}>
				{label} &nbsp;
				<span style={textField(field)}>{field !== null && field !== "" ? field : " - "}</span>
				{extra && (
					<span style={{ ...textField(field), color: colorExtra ?? "black" }}>
						{typeof extra === "object" ? extra : extra !== null && extra !== "" ? " - " + extra : ""}
					</span>
				)}
				<span style={textField(field)}>{secondExtra !== null && secondExtra !== "" ? " - " + secondExtra : ""}</span>
			</span>
		</div>
	);
};

export default ContainerFieldPrescription;
